//@ts-ignore
import ImageBlobReduce from 'image-blob-reduce';
//@ts-ignore
import Pica from 'pica';
import * as Sentry from '@sentry/browser';

import { storage } from './firebaseHelper';

const pica = Pica({ features: ['js', 'wasm', 'cib'] });
const reduce = new ImageBlobReduce({ pica });

/**
 * Helper functions to upload multiple image to firebase storage
 * @param {Array} images
 */
export async function uploadMultipleImages(images, params) {
  let allImages = [];
  const order = [];
  storage.ref().constructor.prototype.putFiles = function(files) {
    var ref = this;
    return Promise.all(
      files.map(async function(file, index) {
        order[file.index] = file.path;

        // doc for options https://github.com/nodeca/image-blob-reduce#toblobin_blob-options--promiseout_blob
        return reduce
          .toBlob(file, { max: 1200 })
          .then(blob => {
            let childHref = '';
            if (params['authorId']) {
              childHref =
                'users/' + params['authorId'] + '/profile/avatar_' + file.name;
            } else if (params['msgId']) {
              childHref = 'messages/' + params['msgId'] + '/' + file.name;
            } else {
              childHref = 'classifieds/' + params['adsId'] + '/' + file.name;
            }
            return ref.child(childHref).put(blob);
          })
          .catch(error => {
            console.warn('reduce error => ', error);
            Sentry.captureException(error);
          });
      })
    ).catch(error => {
      console.warn('error caught', error);
      Sentry.captureException(error);
    });
  };

  const getOrderKey = value => {
    return Object.keys(order).find(key => order[key] === value) || 0;
  };

  const metadata = {
    cacheControl: 'public,max-age=7776000,s-maxage=7776000',
  };

  const uploadedImages = await storage
    .ref()
    .putFiles(images, { metadata })
    .then(data => {
      return data;
    });

  return Promise.all(
    uploadedImages.map(snapshot => {
      return new Promise(async (resolve, reject) => {
        await snapshot.ref.getDownloadURL().then(function(downloadURL) {
          const index = getOrderKey(snapshot.metadata.name);
          allImages[index] = downloadURL;
        });
        resolve(allImages);
      });
    })
  );
}
